import DynamicTitleWithTooltip from "../components/DynamicTitleWithTooltip";
import Form from "./Form";
import { Edit as RaEdit } from "react-admin";
import React from "react";
import useManageOpenEditTabs from "../components/useManageOpenEditTabs";

const getValueConverterTitle = (record, translate) =>
  `${translate("value-converter.label")} ${record.id} (${record.name})`;

const Edit = (props) => {
  const id = props.id?.toString(); // ID della risorsa
  useManageOpenEditTabs(props.resource, id);

  return (
    <RaEdit
      undoable={false}
      {...props}
      title={<DynamicTitleWithTooltip getTitle={getValueConverterTitle} />}
    >
      <Form />
    </RaEdit>
  );
};

export default Edit;
